import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicBusinessProjectFormSubmitPublicRoute: InvariantJiraRoute = {
	name: 'classic-business-form-submit-public',
	path: '/jira/core/form/:formUuid',
	exact: true,
};
